import React from "react";
import { Button } from "./PlanToken.styles";
import type { PlanTokenProps } from "./PlanToken.types";

/** An inline, editable piece of a sentence: a real button with a dashed underline. */
export const PlanToken: React.FC<PlanTokenProps> = ({ label, onClick, tone = "default", ariaLabel, className }) => (
  <Button type="button" className={className} $tone={tone} onClick={onClick} aria-label={ariaLabel}>
    {label}
  </Button>
);

export default PlanToken;
